import { UnauthApi } from '@/api';

type GiftProductListQuery = NonNullable<
  Parameters<(typeof UnauthApi)['get:/wello/v2/allows/home/gift-product']>[0]
>['query'];

export const getGiftProductList = async (query: GiftProductListQuery) => {
  const response = await UnauthApi['get:/wello/v2/allows/home/gift-product']({
    query: {
      //* 목록 조회는 기본이 「품절 제외」라, 빼먹으면 품절 답례품이 목록에서 사라진다
      includeSoldOutYN: true,
      ...query,
    },
  });

  return response.data?.context;
};

export type GiftProductList = NonNullable<
  Awaited<ReturnType<typeof getGiftProductList>>
>;

export type GiftProductListItem = GiftProductList['contents'][number];
